"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entityIndexTooHeavyRule = void 0;
exports.hasTooHeavyIndexes = hasTooHeavyIndexes;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
const ruleId = 'entity-index-too-heavy';
const ruleName = 'entity with too heavy indexes';
const ruleDescription = 'entities with index weight over data exceeding threshold';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.EntityId.array().optional(),
    ratio: zod_1.z.number(),
}).strict().describe('EntityIndexTooHeavyConf');
exports.entityIndexTooHeavyRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.medium, ratio: 1 },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.entityRefFromId) || []);
        return (db.entities || [])
            .filter(e => hasTooHeavyIndexes(e, conf.ratio))
            .filter(e => !ignores.some(i => (0, databaseUtils_1.entityRefSame)(i, (0, databaseUtils_1.entityToRef)(e))))
            .map(e => {
            const ratio = e.stats?.sizeIdx && e.stats?.size ? e.stats.sizeIdx / e.stats.size : 0;
            return {
                ruleId,
                ruleName,
                ruleLevel: conf.level,
                message: `Entity ${(0, databaseUtils_1.entityToId)(e)} has too heavy indexes (${(0, utils_1.prettyNumber)(ratio)}x data size, ${(e.pk ? 1 : 0) + (e.indexes?.length || 0)} indexes).`,
                entity: (0, databaseUtils_1.entityToRef)(e),
                extra: { ratio }
            };
        })
            .sort((a, b) => -(a.extra.ratio - b.extra.ratio));
    }
};
function hasTooHeavyIndexes(entity, ratio) {
    return entity.stats?.sizeIdx && entity.stats?.size ? entity.stats.sizeIdx / entity.stats.size > ratio : false;
}
//# sourceMappingURL=entityIndexTooHeavy.js.map